// extracted by mini-css-extract-plugin
export var item = "item-template-module--item--1k_ro";
export var title = "item-template-module--title--2SfiI";
export var subtitle = "item-template-module--subtitle--1w_ng";
export var picWrap = "item-template-module--picWrap--2VZtt";
export var pic = "item-template-module--pic--2C9Vl";
export var sceleton = "item-template-module--sceleton--N7CWP";
export var sceleton_image = "item-template-module--sceleton_image--2gfO8";
export var sceleton_title = "item-template-module--sceleton_title--3rkJ_";
export var sceleton_description = "item-template-module--sceleton_description--2PM0V";